function deleteTempPromoContent(itemID) {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/promoted-content`, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      item_id: `${itemID}`,
    },
  })
    .then((response) => response.json())
    .then((responseJSON) => {
      return responseJSON;
    });
}

export default deleteTempPromoContent;
